import { artifactPackageIdFromTabKey } from '../../projection/canvas/artifactDocumentView.js';

function object(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

function array(value) {
  return Array.isArray(value) ? value : [];
}

function text(value) {
  return String(value ?? '').trim();
}

function findPackage(artifactDocument = {}, activeTabKey = '') {
  const packageId = artifactPackageIdFromTabKey(activeTabKey);
  if (!packageId) {
    return {};
  }
  return array(object(artifactDocument).procurement_packages)
    .map((item) => object(item))
    .find((item) => text(item.package_id || item.id || item.key) === packageId) || {};
}

function findFieldPack(packageItem = {}, action = {}) {
  const payload = object(action.payload);
  const targetPackId = text(payload.field_pack_id || action.field_pack_id);
  const packs = array(object(packageItem).field_pack_suggestions).map((item) => object(item));
  if (!targetPackId) {
    return packs[0] || {};
  }
  return packs.find((pack) => text(pack.field_pack_id || pack.id || pack.key) === targetPackId) || {};
}

function fieldLine(field = {}) {
  const item = object(field);
  const label = text(item.label || item.field_key || item.key);
  const value = text(item.value ?? item.field_value ?? item.raw_value);
  if (!label) {
    return '';
  }
  return `- ${label}${value ? `：${value}` : ''}`;
}

function fieldPackMarkdown(fieldPack = {}) {
  const pack = object(fieldPack);
  const label = text(pack.label || pack.field_pack_id) || '字段包';
  const source = text(pack.source_kind || pack.source);
  const lines = array(pack.fields)
    .map(fieldLine)
    .filter(Boolean);
  if (lines.length === 0) {
    return '';
  }
  return [
    `## 已填入字段包：${label}`,
    source ? `来源：${source}` : '',
    ...lines,
  ].filter(Boolean).join('\n');
}

export function buildFieldPackAppliedDraft({
  action = {},
  activeTabKey = '',
  artifactDocument = {},
  currentContent = '',
} = {}) {
  const packageItem = findPackage(artifactDocument, activeTabKey);
  const fieldPack = findFieldPack(packageItem, action);
  const patchMarkdown = fieldPackMarkdown(fieldPack);
  const content = text(currentContent);
  if (!patchMarkdown) {
    return content;
  }
  if (content.includes(patchMarkdown)) {
    return content;
  }
  return [content, patchMarkdown].filter(Boolean).join('\n\n');
}

export default buildFieldPackAppliedDraft;
